export class DadosCurso {

  public constructor() {
    this.NomeCurso = [];
    this.CodigoEMEC = [];
    this.NomeHabilitacao = [];
    this.TituloConferido = [];
    this.GrauConferido = [];
    this.Endereco = [];
    this.Autorizacao = [];
    this.Reconhecimento = [];
  }

  NomeCurso: string[];
  CodigoEMEC: string[];
  NomeHabilitacao: string[];
  TituloConferido: string[];
  GrauConferido: string[];
  Endereco: Endereco[];
  Autorizacao: Autorizacao[];
  Reconhecimento: Reconhecimento[];
}

export class Autorizacao {

  public constructor() {
    this.Tipo = "";
    this.Numero = "";
    this.Data = "";
  }

  Tipo: string;
  Numero: string;
  Data: string;
}

export class Reconhecimento {

  public constructor() {
    this.Tipo = "";
    this.Numero = "";
    this.Data = "";
  }

  Tipo: string;
  Numero: string;
  Data: string;
}

export class Endereco {

  public constructor() {
    this.Logradouro = "";
    this.Numero = "-";
    this.Complemento = "-";
    this.Bairro = "";
    this.CEP = "";
    this.Municipio = "";
    this.CodMunicipio = "";
    this.UF = "";
  }
  Numero: string;
  Logradouro: string;
  Complemento: string;
  Bairro: string;
  CEP: string;
  Municipio: string;
  CodMunicipio: string;
  UF: string
};
